// File: /src/components/clients/ClientsTableView.js

import React, { useCallback } from 'react';
import { FaArchive, FaInbox } from 'react-icons/fa';
import ClientsTable from '../ClientsTable';
import ProjectTable from '../ProjectTable';
import InvoicesTable from '../InvoicesTable';

const ClientsTableView = ({
	clients,
	services,
	invoices,
	cardColors,
	showArchived,
	onToggleArchived,
	selectedClients,
	toggleSelectClient,
	selectedProjects,
	toggleSelectProject,
	selectedInvoices,
	toggleSelectInvoice,
	onColorChange,
	onOpenClientModal,
}) => {
	const handleColorPicker = useCallback(
		(clientId) => {
			if (typeof document === 'undefined') {
				return;
			}

			const input = document.createElement('input');
			input.type = 'color';
			input.value = cardColors[clientId] || '#ccc';
			input.addEventListener(
				'change',
				(event) => {
					onColorChange(clientId, event.target.value);
				},
				{ once: true },
			);
			input.click();
		},
		[cardColors, onColorChange],
	);

	return (
		<>
			<div className="archive-toggle-container">
				<div
					className="archive-toggle-switch"
					onClick={onToggleArchived}
				>
					<span className="toggle-text">
						{showArchived
							? 'Visualizando arquivados'
							: 'Visualizar arquivados'}
					</span>
					{showArchived ? (
						<FaInbox className="toggle-icon" />
					) : (
						<FaArchive className="toggle-icon" />
					)}
				</div>
			</div>

			<ClientsTable
				clients={clients}
				openClientModal={onOpenClientModal}
				selectedClients={selectedClients}
				toggleSelectClient={toggleSelectClient}
				cardColors={cardColors}
				onColorChange={handleColorPicker}
				isShowingArchived={showArchived}
			/>

			<ProjectTable
				services={services}
				clients={clients}
				openClientModal={onOpenClientModal}
				selectedProjects={selectedProjects}
				toggleSelectProject={toggleSelectProject}
				isShowingArchived={showArchived}
			/>

			<InvoicesTable
				invoices={invoices}
				services={services}
				clients={clients}
				openClientModal={onOpenClientModal}
				selectedInvoices={selectedInvoices}
				toggleSelectInvoice={toggleSelectInvoice}
				isShowingArchived={showArchived}
			/>
		</>
	);
};

export default ClientsTableView;
